import styled from 'styled-components';
import media from '../../../styles/media.style';

import {
  BLACK,
  WHITE,
  BG_GRAY,
  NAVIGATION_MOBILE_HEIGHT,
  NAVIGATION_DESKTOP_HEIGHT,
} from '../../../styles/variables.style';

export const Wrapper = styled.div`
  background: ${BLACK};
  color: ${WHITE};
  flex-grow: 1;
  padding: 25px 0;
  margin-top: ${NAVIGATION_MOBILE_HEIGHT}px;

  ${media.tabletP`
    margin-top: ${NAVIGATION_DESKTOP_HEIGHT}px;
  `};
`;

// to be replaced by proper svgs
export const Button = styled.div`
  height: 40px;
  width: 40px;
  position: relative;
`;

export const ButtonContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContentContainer = styled.div`
  flex: 9;
`;

export const VisitDate = styled.h5`
  margin-bottom: 0;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.1px;
`;

export const Navigation = styled.div`
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 2.08;
  display: flex;
  padding: 0 16px;

  ${media.tabletP`
    align-items: flex-end;
    padding: 27px 50px 0;
  `};
`;

export const NextPage = styled.span`
  text-transform: uppercase;
  margin-right: 20px;
  order: -1;

  ${media.tabletP`
    margin-right: 0;
    order: 0;
  `};
`;

export const CurrentPage = styled.span`
  text-transform: uppercase;
  text-decoration: underline;

  ${media.tabletP`
    margin-right: 20px;
    margin-left: auto;
  `};
`;

export const SalonActivities = styled.h4`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.71;
  letter-spacing: 0.1px;
`;

export const Stylist = styled.h4`
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.1px;
`;

export const Title = styled.h3`
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.3px;
  text-transform: uppercase;
`;

export const AddNewVisitWrapper = styled.div`
  padding: 0 16px;

  ${media.tabletP`
    padding: 0 50px;
  `};
`;

export const VisitsContainer = styled.div`
  background: ${BG_GRAY.COMMON_8};
  padding: 0 16px;

  > div + div {
    position: relative;
    ::before {
      content: '';
      position: absolute;
      top: -13px;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: #e0e0e0;
    }
  }

  ${media.tabletP`
    padding: 0 50px;
  `};
`;

export const Item = styled.div`
  display: flex;
  width: 100%;
  padding: 0;
  margin: 20px 0;

  :first-child {
    padding-top: 30px;
  }

  :last-child {
    margin: 0;
    padding-bottom: 30px;
  }

  ${media.tabletP`
    padding: 0 10%;
  `};
`;

export const PlusIcon = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  display: inline-block;
  width: 40px;
  height: 40px;
  color: ${BLACK};
  background-color: ${WHITE};
  border-radius: 50%;
  vertical-align: middle;
  line-height: 40px;
  padding-left: 12px;

  ${media.tabletP`
    left: 30px;
  `};

  ::after {
    content: '';
    width: 18px;
    height: 2px;
    background-color: ${BLACK};
    position: absolute;
    top: 51%;
    left: 51%;
    transform: translate(-50%, -50%);
  }

  ::before {
    content: '';
    width: 18px;
    height: 2px;
    background-color: ${BLACK};
    position: absolute;
    top: 51%;
    left: 51%;
    transition: transform 0.3s;
    transform: translate(-50%, -50%) rotate(90deg);
  }
`;

export const TextIcon = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  display: inline-block;
  width: 40px;
  height: 40px;
  color: ${BLACK};
  background-color: transparent;
  border: 1px solid ${WHITE};
  border-radius: 50%;
  vertical-align: middle;
  line-height: 40px;
  padding-left: 12px;

  ${media.tabletP`
    left: 30px;
  `};

  ::after {
    content: '';
    width: 10px;
    height: 1px;
    background-color: ${WHITE};
    position: absolute;
    top: 68%;
    left: 41%;
    transform: translate(-50%, -50%);
  }

  ::before {
    content: '';
    width: 18px;
    height: 18px;
    background: linear-gradient(
      to bottom,
      transparent,
      transparent 30%,
      ${WHITE} 30%,
      ${WHITE} 35%,
      transparent 35%,
      transparent 60%,
      ${WHITE} 60%,
      ${WHITE} 65%,
      transparent 65%,
      transparent 100%
    );
    position: absolute;
    top: 47%;
    left: 51%;
    transition: transform 0.3s;
    transform: translate(-50%, -50%);
  }
`;



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/SalonVisitsPage/SalonVisitsPage.style.js